import { apiCall } from "../../../../../_utils";
import { apiUrls } from "../../../../../_constants";

export const draftMealPlanService = {
    getSendMealPlans,
    updateGeneralMealPlan,
    updateMealRoaster,
    getDailyMealRoaster,
    deleteDailyMealPlan,
    sendForApproval,
    deleteDailyMealRoaster,
    getFoodItems
};

function getSendMealPlans(params) {
    return apiCall("GET", apiUrls.food.mealPlan, null, params);
}

function updateGeneralMealPlan(request, id) {
    return apiCall("PUT", `${apiUrls.food.mealPlan}/${id}`, request);
}

function updateMealRoaster(request, id) {
    return apiCall("PUT", `${apiUrls.food.mealPlan}/${id}/roster`, request);
}

function getDailyMealRoaster(id){

    return apiCall("GET",`${apiUrls.food.mealPlan}/${id}/roster`)
   }

 function deleteDailyMealPlan(id) {
    return apiCall("DELETE", `${apiUrls.food.mealPlan}/${id}`);
  }   

  function sendForApproval(id){
    return apiCall("POST",`${apiUrls.food.mealPlan}/${id}/submit`)
}

function deleteDailyMealRoaster(id) {
    return apiCall("DELETE", `${apiUrls.food.mealPlan}/roster/${id}`);
  }  

  function getFoodItems(params){
    return apiCall("GET",apiUrls.food.library,null,params)  
}